export const DEFAULT_SALES_FEES_VALUES = {
  salesFeesForm: {
    salesFees: undefined,
    salesDocumentFees: undefined,
    titleRegistrationLicense: 0,
  },
};
